import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import axios from "axios";
import { apiRoot, UserContext } from "..";
import { Spinner, ToggleButton, ToggleButtonGroup } from "react-bootstrap";

const DeleteDocumentModal = (props) => {
  return (
    <Modal
    show={props.show}
    onHide={props.handleCancel}
    backdrop="static"
    keyboard={false}
    >
    <Modal.Header closeButton>
      <Modal.Title>Odstranit dokument</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {props.errorMessage && <div className="alert alert-danger" role="alert">{props.errorMessage}</div>}
      Chcete opravdu odstranit tento dokument?
    </Modal.Body>
    <Modal.Footer>
      {props.proceeding ? <Spinner as="span" animation="border" size="sm" /> : <></>}
      <Button variant="secondary" onClick={props.handleCancel} disable={props.proceeding.toString()}>Zrušit</Button>
      <Button variant="danger" onClick={props.handleProceed} disable={props.proceeding.toString()}>
        <i className="fa fa-trash-o" aria-hidden="true"></i> Odstranit dokument
      </Button>
    </Modal.Footer>
    </Modal>
  )
}

const Documents = () => {
  const user = useContext(UserContext);
  const queryClient = useQueryClient();

  const fetchDocumentsQuery = useQuery(['fetchDocuments'], async () => {
    const {data} = await axios.get(apiRoot + '/documents');

    let documentGroups = data.documentGroups;
    let years = [];
    data.documents.forEach(document => {
      const documentGroup = data.documentGroups.find((dg) => {
        return dg.id === document.documentGroupId;
      });
      if (!documentGroup.documents) {
        documentGroup.documents = [];
      }
      documentGroup.documents.push(document);

      const uploadedYear = document.uploaded.substring(0, 4);
      let year = years.find(yr => yr.name === uploadedYear);
      if (!year) {
        year = {
          id: uploadedYear,
          name: uploadedYear
        };
        years.push(year);
      }
      if (!year.documents) {
        year.documents = [];
      }
      year.documents.push(document);
    });

    documentGroups = documentGroups.filter((dg) => dg.documents && dg.documents.length > 0);

    const result = {
      documentGroups: documentGroups,
      years: years,
    };
    return result;
  }, {
    onError: (err) => {
      console.log('fetchDocuments error: ' + err) // TODO
    }
  });

  const [showAs, setShowAs] = useState("documentGroups");

  const handleShowAsChange = (val) => {
    setShowAs(val);
  }

  const [documentIdForDelete, setDocumentIdForDelete] = useState(null);

  const deleteDocumentMutation = useMutation((documentId) => {
    return axios.delete(apiRoot  + '/documents/' + documentId);
  },
  {
    onSuccess: () => {
      queryClient.invalidateQueries(['fetchDocuments']);
      setDocumentIdForDelete(null);  
    },
    onError: (error) => {
      console.log("deleteDocumentMutation error: " + error) // TODO
    }
  });

  const deleteDocumentProceed = () => {  
    deleteDocumentMutation.mutate(documentIdForDelete);
  };

  const deleteDocumentCancel = () => {
    setDocumentIdForDelete(null);
    deleteDocumentMutation.reset();
  };

  return (
    <>
<div>
<span>
<i className="fa fa-file-text-o fa-3x fa-in-header align-middle" aria-hidden="true"></i>
<h2 className="d-inline-block align-middle">Dokumenty</h2>
</span>
{user && user.isPowerUser &&
<span> <Link to={"/pridat-dokument"} className="btn btn-success align-middle" role="button"><i className="fa fa-plus" aria-hidden="true"></i> Přidat dokument</Link></span>
}
</div>
{fetchDocumentsQuery.isLoading &&
<div className="text-center">
  <Spinner animation="border" variant="secondary" role="status">
    <span className="visually-hidden">Nahrávám...</span>
  </Spinner>
</div>
}
{fetchDocumentsQuery.isError &&
  <div className="alert alert-danger" role="alert">Chyba při nahrávání dokumentů.</div>
}
<div>&nbsp;</div>
{fetchDocumentsQuery.data && <>
<ToggleButtonGroup type="radio" size="lg" name="showAs" value={showAs} onChange={handleShowAsChange}>
  <ToggleButton id="tbg-radio-groups" variant="outline-primary" value={"documentGroups"}>
    Podle skupin
  </ToggleButton>
  <ToggleButton id="tbg-radio-years" variant="outline-primary" value={"years"}>
    Podle roků
  </ToggleButton>
</ToggleButtonGroup>
<div>&nbsp;</div>
<Accordion alwaysOpen>{fetchDocumentsQuery.data[showAs === "years" ? "years" : "documentGroups"].map(group => (
  <Accordion.Item key={group.id} eventKey={group.id}>
  <Accordion.Header><h4>{group.name} ({group.documents.length})</h4></Accordion.Header>
    <Accordion.Body>
      {group.documents.map(document => (
        <div key={document.id} style={{margin: '10px 0 10px 0', padding: '5px', border: '1px solid #aaaaaa', borderRadius: '5px', backgroundColor: '#eeeeee'}}>
            <div style={{marginBottom: '1em', fontWeight: 'bold', fontSize: '150%'}}><a href={apiRoot + '/documents/' + document.id + '/download/' + window.btoa(document.id + ':' + window.sessionStorage.getItem('jwtToken'))}>{document.name}</a></div>
            <div className="text-break">{document.description}</div>
            <div style={{fontStyle: 'italic', textAlign: 'right'}}>Přidal: {document.uploader}, {document.uploaded}</div>
            {user && user.isPowerUser &&
            <div style={{textAlign: 'right'}}><button className="btn btn-danger" onClick={() => {setDocumentIdForDelete(document.id)}}><i className="fa fa-trash-o" aria-hidden="true"></i> Odstranit dokument</button></div>
            }
        </div>
      ))}
    </Accordion.Body>
  </Accordion.Item>
))}
</Accordion>
</>}

  <DeleteDocumentModal show={documentIdForDelete} proceeding={deleteDocumentMutation.isLoading}
    handleProceed={deleteDocumentProceed} handleCancel={deleteDocumentCancel}
    errorMessage={deleteDocumentMutation.isError ? deleteDocumentMutation.error.message : null} />
    </>
  );
};

export default Documents;